import React from "react";

interface CalendarIconProps {
  className?: string;
}

export const CalendarIcon: React.FC<CalendarIconProps> = ({
  className = "",
}) => {
  return (
    <div style={{ padding: "4px" }}>
      <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.2 4.8016V8.0032C7.2 8.2272 7.2928 8.4272 7.4408 8.5728L9.4168 10.5488C9.56713 10.6982 9.77046 10.782 9.9824 10.782C10.1943 10.782 10.3977 10.6982 10.548 10.5488C10.6976 10.3984 10.7816 10.1949 10.7816 9.9828C10.7816 9.77067 10.6976 9.56717 10.548 9.4168L8.8 7.6688V4.8032C8.8 4.80213 8.8 4.80107 8.8 4.8V3.2C8.8 2.98783 8.71571 2.78434 8.56569 2.63431C8.41566 2.48429 8.21217 2.4 8 2.4C7.78783 2.4 7.58434 2.48429 7.43431 2.63431C7.28429 2.78434 7.2 2.98783 7.2 3.2V4.8016V4.8016ZM8 16C3.5816 16 0 12.4184 0 8C0 3.5816 3.5816 0 8 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8 16Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};
